module.exports = __webpack_public_path__ + "img/kbank.76ae1390.jpg";